export default class CookiePolicy {
    constructor(elem, APP) {
        this.elem = elem
        this.btnAccept = this.elem.querySelector('.cookieBar-submit')
        this.btnReject = this.elem.querySelector('.cookieBar-reject')
    }

    // Cookie needs to expire in 6 months; if it is set, don't show the bar
    setCookie() {
        let expiry = new Date(); //get the current date
        expiry.setMonth(expiry.getMonth() + 6); //add one month to it
        document.cookie = "CookiePolicyShown=true; expires=" + expiry.toUTCString() + "; path=/";
    }

    hideBar() {
        this.elem.classList.add('is-hidden');
        setTimeout(() => this.elem.classList.add('is-removed'), 500); // accessibly hide after animation
    }

    hasCookie() {
        return (document.cookie.includes('CookiePolicyShown'))
    }

    init() {
        if (!this.hasCookie()) {
            this.elem.classList.remove('is-hidden');
        }

        this.btnAccept.addEventListener('click', () => {
            this.setCookie()
            setTimeout(() => this.hideBar(), 500)
        })
        this.btnReject.addEventListener('click', () => {
            // don't enable cookies
            // this.setCookie()
            setTimeout(() => this.hideBar(), 500)
        })

    }
}